var myProject = require('./myProject');
const envSettings = myProject[myProject.environment];
module.exports = {
    fi: {
        home: envSettings.rootPath + "/fi/",
        app: envSettings.rootPath + "/fi/sovellus/",
        appCaption: "Sovelluksen ohjeet",
        appPageAndroid: "https://play.google.com/store/apps/details?id=com.youpret.app",
        appPageIOS: "https://apps.apple.com/fi/app/youpret-tilaa-tulkki/id6448171685",
        appPageAndroidAcademy: "https://play.google.com/store/apps/details?id=com.youpret.academy",
        appPageIOSAcademy: "https://apps.apple.com/fi/app/youpret-academy/id6450000176?l=fi&platform=iphone",
        appPresentation: "/fi/tulkkaus/ajankohtaista/varaa-maksuton-youpret-sovelluksen-kayttoonottokoulutus/",
        appPresentationCaption: "Käyttöönottokoulutus",
        aboutUs: envSettings.rootPath + "/fi/youpret-tyopaikkana/",
        aboutUsCaption:"Youpret työpaikkana",
        becomeInterpreter: envSettings.rootPath + "/fi/tulkiksi/",
        becomeTranslator: envSettings.rootPath + "/fi/kaantajaksi/",
        becomeTranslatorCaption: "Hae kääntäjäksi",

        translation: envSettings.rootPath + "/fi/kaannos/",/* generated language pairs ???*/
        translationCaption: "Käännös",
        translationLanguagesCaption: "Käännöskielet",
        translationLanguages: "/fi/kaannoskielet/", /* permalinks! */
        translationFinnishSwedish: "/fi/kaannos/suomi-ruotsi/",  /* permalinks? */
        translationFinnishSwedishCaption: "Käännös: Suomi - Ruotsi",
        translationFinnishRussian: "/fi/kaannos/suomi-venaja/",  /* permalinks? */
        translationFinnishRussianCaption: "Käännös: Suomi - Venäjä",
        translationFinnishEnglish: "/fi/kaannos/suomi-englanti/",  /* permalinks? */
        translationFinnishEnglishCaption: "Käännös: Suomi - Englanti",
        translationFinnishGerman: "/fi/kaannos/suomi-saksa/",  /* permalinks? */
        translationFinnishGermanCaption: "Käännös: Suomi - Saksa",
        translationFinnishNorwegian: "/fi/kaannos/suomi-norja-kirjanorja/",  /* permalinks? */
        translationFinnishNorwegianCation: "Käännös: Suomi - Norja (Kirjanorja)",

        becomeInterpreterCaption: "Hae tulkiksi",
        becomeInterpreterCompensationAndJobDesc: envSettings.rootPath + "/fi/tulkiksi/palkkiot-ja-tyonkuvaus/",
        becomeInterpreterCompensationAndJobDescCaption: "Tulkin palkka, palkkio ja työnkuva",
        bcorpRaport: "/fi/b-corp/",
        bcorpRaportCaption: "B Corp -sertifikaatti",
        bcorpPart1blogPost: "/fi/tulkkaus/ajankohtaista/b-corp/",
        bcorpPart2blogPost: "/fi/tulkkaus/ajankohtaista/b-corp-osa-2/",

        compensation: envSettings.rootPath + "/fi/tulkiksi/palkkiot-ja-tyonkuvaus/",
        compensationCaption: "Palkkiot ja työnkuvaus",
        contact: envSettings.rootPath + "/fi/yhteys/",
        contactCaption: "Ota yhteyttä",
        createAccount: envSettings.rootPath + "/fi/luo-tunnus/",
        createAccountCaption: "Luo tunnus",
//        createAccount2: envSettings.rootPath + "/fi/luo-tunnus-2/",
//        createAccount3: envSettings.rootPath + "/fi/luo-tunnus-3/",
        customersStories: envSettings.rootPath + "/fi/asiakastarinat/",
        customersStoriesCaption: "Asiakastarinat",
        ethicalGuideForInterpreters: envSettings.rootPath + "/fi/tulkkien-eettiset-ohjeet/",
        ethicalGuideForInterpretersCaption: "Tulkkien eettiset ohjeet",
        help: envSettings.rootPath + "/fi/ukk/",
        helpCaption: "Usein kysytyt kysymykset",
        interpretationServices: envSettings.rootPath + "/fi/tulkkauspalvelut",
        InterpretetionServicesCaption: "Tulkkauspalvelut asiakkaille",
        interpretersCareerStories: envSettings.rootPath + "/fi/tulkkaus/tarinat/",
        interpretersCareerStoriesCaption: "Tulkkien uratarinat",
        login: envSettings.rootPath + "/fi/kirjaudu/",
        loginCaption: "Kirjaudu",
        news: envSettings.rootPath + "/fi/tulkkaus/ajankohtaista/",
        newsCaption: "Ajankohtaista",
        newsLetter: envSettings.rootPath + "/fi/tilaa-uutiskirje/",
        newsLetterCaption: "Tilaa uutiskirje",
        order: envSettings.rootPath + "/fi/tilaa/",
        orderCaption: "Tilaa",
        order2: envSettings.rootPath + "/fi/tilaa-2/",
        orderInterpreter: envSettings.rootPath + "/fi/tilaa-tulkki/",
        orderInterpreterCaption: "Tilaa tulkki",
        orderInterpreterCaption2: "Tilaa tulkki -sivulta",
        orderInterpreter2: envSettings.rootPath + "/fi/tilaa-tulkki/valitse-ajankohta/",
        orderInterpreter3: envSettings.rootPath + "/fi/tilaa-tulkki/tilaajan-yhteystiedot/",
        orderInterpreter4: envSettings.rootPath + "/fi/tilaa-tulkki-kiitos/",
        orderOnSiteInterpreter: envSettings.rootPath + "/fi/tilaa-tulkki/lasnaolotulkki/valitse-kieli/",
        orderOnSiteInterpreter2: envSettings.rootPath + "/fi/tilaa-tulkki/lasnaolotulkki/valitse-ajankohta/",
        orderOnSiteInterpreter3: envSettings.rootPath + "/fi/tilaa-tulkki/lasnaolotulkki/valitse-sijainti/",
        orderOnSiteInterpreter4: envSettings.rootPath + "/fi/tilaa-tulkki/lasnaolotulkki/tilaajan-yhteystiedot/",
        orderInstantInterpreter: envSettings.rootPath + "/fi/tilaa-pikatulkki/",
        prices: envSettings.rootPath + "/fi/hinnat/",
        pricesCaption: "Hinnat",
        privacyPolicy: envSettings.rootPath + "/fi/tietosuoja/",
        privacyPolicyCaption: "Tietosuoja",
        schools: envSettings.rootPath + "/fi/tulkkauspalvelut-kouluille/",
        schoolsCaption: "Tulkkauspalvelut kouluille",
        story: envSettings.rootPath + "/fi/youpret-lyhyesti/",
        storyCaption: "Youpret lyhyesti",
        terms: envSettings.rootPath + "/fi/kayttoehdot/",
        termsCaption: "Käyttöehdot",
        video: envSettings.rootPath + "/fi/video/",
        videoCaption: "Video",
        transfer: envSettings.rootPath + "/fi/viestitulkki/",
        transferCaption: "Viestitulkki",
        transferOrder: envSettings.rootPath + "/fi/viestitulkki/tilaa/",
        externalCalendly: "https://calendly.com/youpretcom",
        externalCalendlyCaption: "Varaa maksuton koulutus/esittely",
        openJobs: envSettings.rootPath + "/fi/avoimet-tyopaikat/harjoittelija/",
        leaveOfferRequest : "Jätä tarjouspyyntö",
        leaveDrivingSchoolOfferRequest : "Autokoulun asiakas, pyydä tarjous tästä",
        leaveDrivingSchoolFlyer: "Autokoulun edustaja, lataa esite asiakkaillesi",
        leaveDrivingSchoolFlyerPdf: "/fi/flyer-autokoulun-teoriakoe",
        drivingSchool: envSettings.rootPath + "/fi/tilaa-tulkki/autokoulun-teoriakoe/",
        leaveLegalOfferRequest : "Jätä maksuton tarjouspyyntö",
        orderInterpreterDrivingSchool1: envSettings.rootPath + "/fi/tilaa-tulkki/autokoulun-teoriakoe/valitse-kieli/",
        orderInterpreterDrivingSchool2: envSettings.rootPath + "/fi/tilaa-tulkki/autokoulun-teoriakoe/valitse-sijainti/",
        orderInterpreterDrivingSchool3: envSettings.rootPath + "/fi/tilaa-tulkki/autokoulun-teoriakoe/valitse-ajankohta/",
        orderInterpreterDrivingSchool4: envSettings.rootPath + "/fi/tilaa-tulkki/autokoulun-teoriakoe/tilaajan-yhteystiedot/",
        orderInterpreterDrivingSchool5: envSettings.rootPath + "/fi/tilaa-tulkki/autokoulun-teoriakoe/maksu-ja-vahvistus/",
        orderInterpreterLegal: envSettings.rootPath + "/fi/tilaa-tulkki/oikeustulkki/",
        orderInterpreterLegal1: envSettings.rootPath + "/fi/tilaa-tulkki/oikeustulkki/valitse-kieli/",
        orderInterpreterLegal2: envSettings.rootPath + "/fi/tilaa-tulkki/oikeustulkki/valitse-tulkkauksen-tyyppi/",
        orderInterpreterLegal3: envSettings.rootPath + "/fi/tilaa-tulkki/oikeustulkki/valitse-sijainti/",
        orderInterpreterLegal4: envSettings.rootPath + "/fi/tilaa-tulkki/oikeustulkki/valitse-ajankohta/",
        orderInterpreterLegal5: envSettings.rootPath + "/fi/tilaa-tulkki/oikeustulkki/tilaajan-yhteystiedot/",
        thankYouOfferRequest: envSettings.rootPath + "/fi/tilaa-tulkki/tarjouspyynto-kiitos/",
        thankYouPage: envSettings.rootPath + "/fi/kiitos/",
        earlyChildhoodEducation: envSettings.rootPath + "/fi/varhaiskasvatusalan-tulkki/",
        earlyChildhoodEducation1: envSettings.rootPath + "/fi/tilaa-tulkki/varhaiskasvatus-tulkki/valitse-kieli/",
        earlyChildhoodEducation2: envSettings.rootPath + "/fi/tilaa-tulkki/varhaiskasvatus-tulkki/valitse-tulkkauksen-tyyppi/",
        earlyChildhoodEducation3: envSettings.rootPath + "/fi/tilaa-tulkki/varhaiskasvatus-tulkki/valitse-sijainti/",
        earlyChildhoodEducation4: envSettings.rootPath + "/fi/tilaa-tulkki/varhaiskasvatus-tulkki/valitse-ajankohta/",
        earlyChildhoodEducation5: envSettings.rootPath + "/fi/tilaa-tulkki/varhaiskasvatus-tulkki/tilaajan-yhteystiedot/",
        orderHealthInterpreter: envSettings.rootPath + "/fi/tilaa-tulkki/terveystulkki/",
        orderHealthInterpreter1: envSettings.rootPath + "/fi/tilaa-tulkki/terveystulkki/valitse-kieli/",
        orderHealthInterpreter2: envSettings.rootPath + "/fi/tilaa-tulkki/terveystulkki/valitse-tulkkauksen-tyyppi/",
        orderHealthInterpreter3: envSettings.rootPath + "/fi/tilaa-tulkki/terveystulkki/valitse-sijainti/",
        orderHealthInterpreter4: envSettings.rootPath + "/fi/tilaa-tulkki/terveystulkki/valitse-ajankohta/",
        orderHealthInterpreter5: envSettings.rootPath + "/fi/tilaa-tulkki/terveystulkki/tilaajan-yhteystiedot/",
        orderMentalHealthInterpreter: envSettings.rootPath + "/fi/mielenterveys/",
        orderMentalHealthInterpreter1: envSettings.rootPath + "/fi/tilaa-tulkki/mielenterveys/valitse-kieli/",
        orderMentalHealthInterpreter2: envSettings.rootPath + "/fi/tilaa-tulkki/mielenterveys/valitse-tulkkauksen-tyyppi/",
        orderMentalHealthInterpreter3: envSettings.rootPath + "/fi/tilaa-tulkki/mielenterveys/valitse-sijainti/",
        orderMentalHealthInterpreter4: envSettings.rootPath + "/fi/tilaa-tulkki/mielenterveys/valitse-ajankohta/",
        orderMentalHealthInterpreter5: envSettings.rootPath + "/fi/tilaa-tulkki/mielenterveys/tilaajan-yhteystiedot/",
        orderBusinessInterpreter: envSettings.rootPath + "/fi/tilaa-tulkki/bisnestulkki/",
        orderBusinessInterpreter1: envSettings.rootPath + "/fi/tilaa-tulkki/bisnestulkki/valitse-kieli/",
        orderBusinessInterpreter2: envSettings.rootPath + "/fi/tilaa-tulkki/bisnestulkki/valitse-tulkkauksen-tyyppi/",
        orderBusinessInterpreter3: envSettings.rootPath + "/fi/tilaa-tulkki/bisnestulkki/valitse-sijainti/",
        orderBusinessInterpreter4: envSettings.rootPath + "/fi/tilaa-tulkki/bisnestulkki/valitse-ajankohta/",
        orderBusinessInterpreter5: envSettings.rootPath + "/fi/tilaa-tulkki/bisnestulkki/tilaajan-yhteystiedot/",
        media: envSettings.rootPath + "/fi/media/",
        mediaCaption: "Medialle",
        newsAlustatalous: envSettings.rootPath + "/fi/tulkkaus/ajankohtaista/alustatalous/",
        pageNotFound: envSettings.rootPath + "/fi/sivua-ei-loydy/",
        pageNotFoundTitle: "Sivua ei löytynyt",
        vipuvoimaaEulta: envSettings.rootPath + "/fi/vipuvoimaa-eulta/",
        softwarePage: envSettings.rootPath + "/fi/sovellukset/",
        softwareContactMessage: envSettings.rootPath + "/fi/sovellukset/yhteydenotto-viestinta/",
        specialInterpretationServices: envSettings.rootPath + "/fi/tilaa-tulkki/asiantuntijatulkit/",
        openJobsCaption : "Avoimet työpaikat",
        openJobsPage: envSettings.rootPath + "/fi/avoimet-tyopaikat/",
        openJobsOpenApplicationPage: envSettings.rootPath + "/fi/avoimet-tyopaikat/avoin-hakemus/",
        openJobsOpenApplicationPageCaption: "avoin hakemus",
        openJobsCustomerService: envSettings.rootPath + "/fi/avoimet-tyopaikat/asiakaspalvelija-harjoittelija/",
        openJobsCustomerServiceCaption: envSettings.rootPath + "Avoin tyopaikka asiakaspalvelija",
        openJobsCustomerServiceTrainee: envSettings.rootPath + "/fi/avoimet-tyopaikat/harjoittelija-asiakaspalvelutiimiin/",
        openJobsCustomerServiceTraineeCaption: envSettings.rootPath + "Avoin tyopaikka harjoittelija asiakaspalvelutiimiin",
        openJobsRecruitmentSpecialist: envSettings.rootPath + "/fi/avoimet-tyopaikat/rekrytoinnin-asiantuntija/",
        openJobsRecruitmentSpecialistCaption: "Avoin tyopaikka rekrytoinnin asiantuntija",
        openJobsLanguageServiceSpecialist: envSettings.rootPath + "/fi/avoimet-tyopaikat/kielipalveluiden-asiantuntija/",
        openJobsLanguageServiceSpecialistCaption: envSettings.rootPath + "Avoin tyopaikka language service specialist",
        openJobsProgrammer: envSettings.rootPath + "/fi/avoimet-tyopaikat/ohjelmistokehittaja/",
        openJobsProgrammerCaption: "Avoin tyopaikka ohjelmistokehittäjä",
        openJobsSalesAssistant: envSettings.rootPath + "/fi/avoimet-tyopaikat/tulkkauspalveluiden-myyja/",
        openJobsSalesAssistantCaption: envSettings.rootPath + "Avoin tyopaikka myyntiassistentti",
        orderIdentifier: "lasnaolotulkki",
        youpretAcademy: envSettings.rootPath + "/fi/academy/",
        youpretAcademyCaption: "Youpret Academy",
        languageTechnology: envSettings.rootPath + "/en/language-technology/",
        languageTechnologyCaption: "Language technology",
        sustainability: envSettings.rootPath + "/fi/vastuullisuus/",
        sustainabilityCaption: "Vastuullisuus",
        whistleblowing: "https://whistleblow.youpret.com/#/",
        whistleblowingCaption: "Ilmoituskanava",
        customersGuide: "/fi/asiakkaan-opas/",
        customersGuideCaption: "Asiakkaan opas",
        specialistInterpretersCustomers: "/fi/tilaa-tulkki/asiantuntijatulkkaus/",
        specialistInterpretersCustomersCaption: "Asiantuntijatulkkaus",
        customersGuidepdf: "https://drive.google.com/file/d/1CrbnVkRXIHKa4Kgu3-gNeAlDXGlrBQKA/view?usp=sharing",
        interpretersChecklistpdf: "https://drive.google.com/file/d/1CNFTxGTxk8FbAAKuSYb6SSRObdo8UK2q/view",
        interpretersChecklistCaption: "Tulkkauksen tarkistuslista",
        interpretersChecklist: "/fi/tulkkauksen-tarkistuslista/",
        customersGuideLabel: "Lataa tästä",
        orderTranslation: envSettings.rootPath +  "/fi/tilaa-kaannos/",
        orderTranslationCaption: envSettings.rootPath +  "Tilaa käännös",
        legalRequirementFramework: envSettings.rootPath +  "https://assets.ctfassets.net/l575jm7617lt/3A9vad06vap7DkMt2LHGpY/c06c6d4388a0caa7e0286ebc70c4c5f8/B_Lab_Legal_Framework_Finland.pdf",
        bCorpBlog: envSettings.rootPath +  "/fi/tulkkaus/ajankohtaista/b-corp/",
        bCorpPage: envSettings.rootPath +  "https://www.bcorporation.net/en-us/find-a-b-corp/company/youpret-oy/",
        sustainabilityReport: envSettings.rootPath +  "https://drive.google.com/file/d/1Qfw-BibvUy5W0BE8_SOFANZctZLOxbTV/view?usp=sharing",
        declarationOfInterdependence: envSettings.rootPath +  "/fi/b-corp/declaration/",
        bCorpBlog2: envSettings.rootPath +  "https://www.bcorporation.net/en-us/find-a-b-corp/company/youpret-oy/",
        civicOrientation: envSettings.rootPath +  "/fi/yhteiskuntaorientaatio/",
        civicOrientationCaption: "Yhteiskuntaorientaatio",
    
    },
    en: {
        home: envSettings.rootPath + "/en/",
        aboutUs: envSettings.rootPath + "/en/about-us/",
        aboutUsCaption:"About us",
        app: envSettings.rootPath +  "/en/app/",
        appCaption: "Download app",
        appPageAndroid: "https://play.google.com/store/apps/details?id=com.youpret.app",
        appPageIOS: "https://apps.apple.com/fi/app/youpret-tilaa-tulkki/id6448171685",
        becomeInterpreter: envSettings.rootPath + "/en/become-an-interpreter/",
        becomeInterpreterCaption: "Become an interpreter",
        becomeInterpreterCompensationAndJobDesc: envSettings.rootPath +  "/en/become-an-interpreter/interpreter-compensation-and-job-description/",
        becomeInterpreterCompensationAndJobDescCaption: "Interpreter compensation and job description",
        bcorpRaport: "/en/b-corp/",
        bcorpRaportCaption: " B Corp certification",
        bcorpPart1blogPost: "/en/interpretation/news/b-corp/",
        bcorpPart2blogPost: "/en/interpretation/news/b-corp-part-2/",

        compensation: envSettings.rootPath +  "/en/become-an-interpreter/interpreter-compensation-and-job-description/",
        compensationCaption: "Compensation and job description",
        contact: envSettings.rootPath +  "/en/contact/",
        contactCaption: "Contact",
        createAccount: envSettings.rootPath +  "/en/sign-up/",
        // createAccount2: envSettings.rootPath + "/en/sign-up-2/",
        // createAccount3: envSettings.rootPath + "/en/sign-up-3/",
        createAccountCaption: "Stofnaðu reikning",
        ethicalGuideForInterpreters: envSettings.rootPath +  "/en/interpreter-code-of-ethic/",
        ethicalGuideForInterpretersCaption: "Interpreter Code of Ethic",
        externalCalendly: "https://calendly.com/youpretcom",
        externalCalendlyCaption: "Book free training / demonstration",
        harnessLanguageTechnology: envSettings.rootPath + "/en/harness-language-technology/",
        harnessLanguageTechnologyCaption: "Language technology",
        help: envSettings.rootPath +  "/en/help/",
        helpCaption: "Guide",
        login: envSettings.rootPath +  "/en/login/",
        interpretersCareerStories: envSettings.rootPath + "/en/interpretation/stories/",
        interpretersCareerStoriesCaption: "Interpreters Career Stories",
        interpreterSchedulingAndManagement: envSettings.rootPath + "interpreter-scheduling-and-management/",
        interpretationServices: envSettings.rootPath + "/en/interpretation-services",
        InterpretetionServicesCaption: "Interpretation services for customers",
        interpretingSystem: envSettings.rootPath + "interpreting-system/",
        languageTechnology: envSettings.rootPath + "/en/language-technology/",
        languageTechnologyCaption: "Language technology",
        login: envSettings.rootPath + "/en/login/",
        loginCaption: "Login",
        machineInterpreting: envSettings.rootPath + "machine-interpreting/",
        news: envSettings.rootPath +  "/en/interpretation/news/",
        newsCaption: "Insights",
        newsLetter: envSettings.rootPath + "/en/subscribe-newsletter/",
        newsLetterCaption: "Subscribe to the newsletter",
        openJobsCustomerService: envSettings.rootPath + "/en/open-jobs/customer-service-representative/",
        openJobsCustomerServiceCaption: envSettings.rootPath + "Open job customer service representative",
        openJobsRecruitmentSpecialist: envSettings.rootPath + "/en/open-jobs/recruitment-specialist/",
        openJobsRecruitmentSpecialistCaption: "Open job recruitment specialist",
        openJobsLanguageServiceSpecialist: envSettings.rootPath + "/en/open-jobs/language-service-specialist/",
        openJobsLanguageServiceSpecialistCaption: envSettings.rootPath + "Open job language service specialist",
        openJobsSalesAssistant: envSettings.rootPath + "/en/open-jobs/sales-assistant/",
        openJobsSalesAssistantCaption: envSettings.rootPath + "Open job sales assistant",
        openJobsProgrammer: envSettings.rootPath + "/en/open-jobs/programmer/",
        openJobsProgrammerCaption: "Open software developer",
        orderInterpreter: envSettings.rootPath +  "/en/order-an-interpreter/",
        order: envSettings.rootPath + "/en/order/",
        orderCaption: "Order",
        order2: envSettings.rootPath + "/en/order-2/",
        orderIdentifier: "on-site",
        orderInterpreterCaption: "Order an interpreter",
        orderInterpreter2: envSettings.rootPath +  "/en/order-an-interpreter/select-date-and-time/",
        orderInterpreter3: envSettings.rootPath +  "/en/order-an-interpreter/customer-contact-information/",
        orderInterpreter4: envSettings.rootPath +  "/en/order-an-interpreter/thank-you/",
        orderInstantInterpreter: envSettings.rootPath + "/en/order-an-interpreter-immediately/",
        orderOnSiteInterpreter: envSettings.rootPath + "/en/order-an-interpreter/on-site/language/",
        orderOnSiteInterpreter2: envSettings.rootPath + "/en/order-an-interpreter/on-site/datetime/",
        orderOnSiteInterpreter3: envSettings.rootPath + "/en/order-an-interpreter/on-site/location/",
        orderOnSiteInterpreter4: envSettings.rootPath + "/en/order-an-interpreter/on-site/customer-information/",
        overThePhoneAndVideoRemoteInterpreting: envSettings.rootPath + "over-the-phone-and-video-remote-interpreting/",
        pageNotFound: envSettings.rootPath + "/en/page-not-found/",
        pageNotFoundTitle: "Page not found",
        prices: envSettings.rootPath + "/en/prices/",
        pricesCaption: "Prices",
        privacyPolicy: envSettings.rootPath + "/en/privacy-policy/",
        privacyPolicyCaption: "Privacy policy",
        schools: envSettings.rootPath + "/en/tulkkauspalvelut-kouluille/",
        schoolsCaption: "Interpretation services for schools",
        story: envSettings.rootPath + "/en/story/",
        storyCaption: "Story",
        streamlinedManagement: envSettings.rootPath + "/en/streamlined-management/",
        streamlinedManagementCaption: "Interpretation Management System",
        sustainability: envSettings.rootPath + "/en/sustainability/",
        sustainabilityCaption: "Sustainability",
        terms: envSettings.rootPath + "/en/terms-of-service/",
        termsCaption: "Terms of service",
        thankYouOfferRequest: envSettings.rootPath + "/en/order-an-interpreter/thank-you/",
        transfer: envSettings.rootPath + "/en/transfer/",
        transferCaption: "Transfer",
        transferOrder: envSettings.rootPath + "/en/transfer/order",
        video: envSettings.rootPath + "/en/video/",
        videoCaption: "Video",
        whistleblowing: "/en/whistleblowing/",
        whistleblowingCaption: "Whistleblowing",
        youpretAcademy: envSettings.rootPath + "/en/youpret-academy/",
        youpretAcademyCaption: "Youpret Academy",
        legalRequirementFramework: envSettings.rootPath +  "https://www.bcorporation.net/en-us/legal-requirement/country/finland/",
        bCorpBlog: envSettings.rootPath +  "https://www.youpret.com/en/interpretation/news/b-corp/",
        bCorpPage: envSettings.rootPath +  "https://www.bcorporation.net/en-us/find-a-b-corp/company/youpret-oy/",
        sustainabilityReport: envSettings.rootPath +  "https://drive.google.com/file/d/1-_i0L0SSW2vwo1ShNWut1G0ENDC_p12B/view?usp=sharing",
        declarationOfInterdependence: envSettings.rootPath +  "/en/b-corp/declaration/",

        translationLanguagesCaption: "Translation languages",
        translationLanguages: "/en/translation-languages/", /* permalinks! */
        translationFinnishSwedish: "/en/translation/finnish-swedish/",  /* permalinks? */
        translationFinnishSwedishCaption: "Translation: Finnish - Swedish",
        translationFinnishRussian: "/en/translation/finnish-russian/",  /* permalinks? */
        translationFinnishRussianCaption: "Translation: Finnish - Russian",
        translationFinnishEnglish: "/en/translation/finnish-english/",  /* permalinks? */
        translationFinnishEnglishCaption: "Translation: Finnish - English",
        translationFinnishGerman: "/en/translation/finnish-german/",  /* permalinks? */
        translationFinnishGermanCaption: "Translation: Finnish - German",
        translationFinnishNorwegian: "/en/translation/finnish-norwegian/",  /* permalinks? */
        translationFinnishNorwegianCation: "Translation: Finnish - Norwegian",
        
    },

    ru: {
        appPresentation: "/ru/perevod/aktualnoye/besplatnoye-obucheniye-rabote-s-prilozheniyem-youpret/",
        appPresentationCaption: "Как работает приложение",
        aboutUs: envSettings.rootPath + "/fi/youpret-tyopaikkana/", /* to be corrected. no page yet */ 
        aboutUsCaption:"О нас", /* to be corrected */
        becomeInterpreter: envSettings.rootPath + "/ru/stat-perevodchikom/",/* to be corrected UUSI SISÄLTÖ TULOSSA */
        becomeInterpreterCaption: "Стать переводчиком",
        contact: envSettings.rootPath + "/ru/kontakty/",
        contactCaption: "Свяжитесь с нами",
        createAccount: envSettings.rootPath + "/ru/registratsiya/",
        createAccountCaption: "Регистрация",
        // createAccount2: envSettings.rootPath + "/ru/registratsiya-2/",
        // createAccount3: envSettings.rootPath + "/ru/registratsiya-3/",
        ethicalGuideForInterpreters: envSettings.rootPath + "/ru/eticheskiye-printsipy-perevodchikov/",
        ethicalGuideForInterpretersCaption: "Этика переводчика",
        harnessLanguageTechnology: envSettings.rootPath + "/ru/lingvisticheskaya-tekhnologiya/",
        harnessLanguageTechnologyCaption: "Лингвистическая технология",
        help: envSettings.rootPath + "/ru/chasto-zadavayemyye-voprosy/",
        helpCaption: "Часто задаваемые вопросы",
        login: envSettings.rootPath + "/ru/vhod/",
        loginCaption: "Вход",
        media: envSettings.rootPath + "/ru/media/",
        mediaCaption: "Для СМИ",
        news: envSettings.rootPath + "/ru/perevod/aktualnoye/",
        newsCaption: "Актуальное",
        newsLetter: envSettings.rootPath + "/ru/rassylka/",
        newsLetterCaption: "Подпишитесь на рассылку",
        orderInstantInterpreter: envSettings.rootPath + "/ru/zakazat-srochnyy-perevod/",
        orderInterpreter: envSettings.rootPath + "/ru/zakazat-perevod/",
        orderInterpreterCaption: "Заказать перевод", 
        orderInterpreter2: envSettings.rootPath + "/ru/zakazat-perevodchika/vyberite-vremya/",
        orderInterpreter3: envSettings.rootPath +  "/ru/zakazat-perevodchika/kontakty-zakazchika/",
        orderInterpreter4: envSettings.rootPath +  "/ru/zakazat-perevod-spasibo/",
        orderOnSiteInterpreter: envSettings.rootPath + "/ru/zakazat-perevod/perevod-na-meste/vybrat-yazyk/",
        orderOnSiteInterpreter2: envSettings.rootPath + "/ru/zakazat-perevodchika/perevod-na-meste/vyberite-vremya/",
        orderOnSiteInterpreter3: envSettings.rootPath + "/ru/zakazat-perevodchika/perevod-na-meste/vyberite-mesto/",
        orderOnSiteInterpreter4: envSettings.rootPath + "/ru/zakazat-perevodchika/perevod-na-meste/kontakty-zakazchika/",
        prices: envSettings.rootPath + "/ru/stoimost-perevoda/",
        pricesCaption: "Стоимость перевода",
        privacyPolicy: envSettings.rootPath + "/fi/tietosuoja/",/* to be corrected */
        privacyPolicyCaption: "Защита данных (англ.)",
        specialInterpretationServices: envSettings.rootPath + "/ru/zakazat-perevodchika/perevodchiki-eksperty/",
        specialInterpretationServicesCaption: "Переводчики-эксперты",
        story: envSettings.rootPath + "/ru/pro-youpret/",/* to be corrected */
        storyCaption: "История Youpret",
        streamlinedManagement: envSettings.rootPath + "/ru/youpret-app/",
        streamlinedManagementCaption: "Управление переводами",
        sustainability: envSettings.rootPath + "/ru/otvetstvennost/",
        sustainabilityCaption: "Устойчивое развитие",
        terms: envSettings.rootPath + "/fi/kayttoehdot/",/* to be corrected */
        termsCaption: "Условия использования (фин.)",
        youpretAcademy: envSettings.rootPath + "/ru/youpret-academy/",
        youpretAcademyCaption: "Youpret Academy",
        orderIdentifier: "perevod-na-meste",
        thankYouOfferRequest: envSettings.rootPath + "/en/thank-you/",
        thankYouPage: envSettings.rootPath + "/en/thank-you/",
        customersGuide: "https://drive.google.com/file/d/1SN2JFXuNquTZ2ujZsFXEN3Qm-KxhMl8p/view",
        customersGuideLabel: "Lataa tästä"

    },
    sv: {
        home: envSettings.rootPath + "/sv/",
        
        app: envSettings.rootPath + "/sv/app/",
        appCaption: "Youpretappen",
        appPageAndroid: "https://play.google.com/store/apps/details?id=com.youpret.app",
        appPageIOS: "https://apps.apple.com/fi/app/youpret-tilaa-tulkki/id6448171685",
        becomeInterpreter: envSettings.rootPath + "/sv/tolk/",
        becomeInterpreterCaption: "Ansök som tolk",
        becomeInterpreterCompensationAndJobDesc: envSettings.rootPath +  "/sv/tolk/ansoka-om-tolk/",
        becomeInterpreterCompensationAndJobDescCaption: "Tolkarnas ersättningar och arbetsbeskrivningen",
        bCorpBlog: envSettings.rootPath +  "/en/interpretation/news/b-corp/",
        bCorpPage: envSettings.rootPath +  "https://www.bcorporation.net/en-us/find-a-b-corp/company/youpret-oy/",
        bcorpPart2blogPost: "/sv/tolk/insikter/b-corp-del-2/",
        bcorpRaport: envSettings.rootPath + "/sv/b-corp/",
        bcorpRaportCaption: "B Corp-ansvarscertifikat",
        compensation: envSettings.rootPath +  "/en/become-an-interpreter/interpreter-compensation-and-job-description/",
        compensationCaption: "",
        contact: envSettings.rootPath +  "/sv/kontakt/",
        contactCaption: "Kontakta oss",
        createAccount: envSettings.rootPath +  "/sv/skapa-anvandarnamn/",
        // createAccount2: envSettings.rootPath + "/sv/skapa-anvandarnamn-2/",
        // createAccount3: envSettings.rootPath + "/sv/skapa-anvandarnamn-3/",
        createAccountCaption: "Skapa användarnamn",
        ethicalGuideForInterpreters: envSettings.rootPath +  "/sv/yrkesetiska-regler-for-kontakttolkar/",
        ethicalGuideForInterpretersCaption: "Yrkesetiska regler för kontakttolkar",
        help: envSettings.rootPath + "/sv/hjalp/",
        helpCaption: "Frågor och svar",
        login: envSettings.rootPath +  "/sv/logga-in/",
        interpretationServices: envSettings.rootPath + "/en/interpretation-services",
        InterpretetionServicesCaption: "Interpretation services for customers",
        loginCaption: "Logga in",
        news: envSettings.rootPath +  "/sv/tolk/insikter/",
        newsCaption: "Insikter",
        newsLetter: envSettings.rootPath + "/en/subscribe-newsletter/",
        orderInterpreter: envSettings.rootPath +  "/sv/boka-tolk/",
        order: envSettings.rootPath + "/en/order/",
        orderCaption: "Order",
        order2: envSettings.rootPath + "/en/order-2/",
        orderInterpreterCaption: "Boka tolk",
        orderInterpreter2: envSettings.rootPath +  "/sv/boka-tolk/valj-tidpunkt/",
        orderInterpreter3: envSettings.rootPath +  "/sv//boka-tolk/kontaktuppgifter/",
        orderOnSiteInterpreter: envSettings.rootPath + "/sv/boka-tolk/kontakt/sprak/",
        orderOnSiteInterpreter2: envSettings.rootPath + "/sv/boka-tolk/kontakt/valj-tidpunkt/",
        orderOnSiteInterpreter3: envSettings.rootPath + "/sv/boka-tolk/kontakt/plats/",
        orderOnSiteInterpreter4: envSettings.rootPath + "/sv/boka-tolk/kontakt/kontaktuppgifter/",
        orderInstantInterpreter: envSettings.rootPath + "/sv/boka-snabbtolk/",
        thankYouOfferRequest: envSettings.rootPath + "/sv/boka-tolk/tack/",
        orderInterpreter4: envSettings.rootPath + "/sv/boka-tolk/tack/",
        prices: envSettings.rootPath + "/sv/priset/",
        pricesCaption: "Priser",
        privacyPolicy: envSettings.rootPath + "/sv/integritetspolicy/",
        privacyPolicyCaption: "Integritetspolicy",
        sustainability: envSettings.rootPath + "/sv/ansvarsfullhet/",
        sustainabilityCaption: "Ansvarsfullhet",
        schoolsCaption: "Interpretation services for schools",
        story: envSettings.rootPath + "/sv/berattelsen-om-youpret/",
        storyCaption: "Berättelsen om oss",
        sustainabilityReport: envSettings.rootPath +  "https://drive.google.com/file/d/1-_i0L0SSW2vwo1ShNWut1G0ENDC_p12B/view?usp=sharing",
        terms: envSettings.rootPath + "/en/terms-of-service/",
        video: envSettings.rootPath + "/en/video/",
        videoCaption: "Video",
        transfer: envSettings.rootPath + "/en/transfer/",
        transferCaption: "Transfer",
        transferOrder: envSettings.rootPath + "/en/transfer/order",
        externalCalendly: "https://calendly.com/youpretcom",
        externalCalendlyCaption: "Book free training / demonstration",
        pageNotFound: envSettings.rootPath + "/en/page-not-found/",
        pageNotFoundTitle: "Page not found",
        orderIdentifier: "kontakt",
        declarationOfInterdependence: envSettings.rootPath +  "/sv/b-corp/declaration/",
    },
    de: {
        home: envSettings.rootPath + "/de/",
        app: envSettings.rootPath + "/de/app/",
        appCaption: "Sovelluksen ohjeet",
        appPageAndroid: "https://play.google.com/store/apps/details?id=com.youpret.app",
        appPageIOS: "https://apps.apple.com/fi/app/youpret-tilaa-tulkki/id6448171685",
        appPageAndroidAcademy: "https://play.google.com/store/apps/details?id=com.youpret.academy",
        appPageIOSAcademy: "https://apps.apple.com/fi/app/youpret-academy/id6450000176?l=fi&platform=iphone",
        appPresentation: "/de/interpretation/aktuelles/kostenlose-einfuhrungen/",
        appPresentationCaption: "Youpret-Schulungen",
        aboutUs: envSettings.rootPath + "/fi/youpret-tyopaikkana/",
        aboutUsCaption:"Youpret työpaikkana",
        becomeInterpreter: envSettings.rootPath + "/de/als-dolmetscher-bewerben/",
        becomeInterpreterCaption: "Als Dolmetscher bewerben",
        becomeInterpreterCompensationAndJobDesc: envSettings.rootPath + "/fi/tulkiksi/palkkiot-ja-tyonkuvaus/",
        becomeInterpreterCompensationAndJobDescCaption: "Tulkkien palkkio ja työnkuvaus",
        compensation: envSettings.rootPath + "/fi/tulkiksi/palkkiot-ja-tyonkuvaus/",
        compensationCaption: "Palkkiot ja työnkuvaus",
        contact: envSettings.rootPath + "/de/kontaktieren-sie-uns/",
        contactCaption: "Kontaktieren Sie uns",
        createAccount: envSettings.rootPath + "/de/benutzerkonto-erstellen/",
        createAccountCaption: "Benutzerkonto erstellen",
        // createAccount2: envSettings.rootPath + "/de/benutzerkonto-erstellen-2/",
        // createAccount3: envSettings.rootPath + "/de/benutzerkonto-erstellen-3/",
        ethicalGuideForInterpreters: envSettings.rootPath + "/fi/tulkkien-eettiset-ohjeet/",
        ethicalGuideForInterpretersCaption: "Tulkkien eettiset ohjeet",
        becomeInterpreter: envSettings.rootPath + "/de/als-dolmetscher-bewerben/",
        becomeInterpreterCaption: "Als Dolmetscher bewerben",
        help: envSettings.rootPath + "/de/haufig-gestelle-fragen/",
        helpCaption: "Häufig gestellte Fragen",
        interpretationServices: envSettings.rootPath + "/fi/tulkkauspalvelut",
        InterpretetionServicesCaption: "Tulkkauspalvelut asiakkaille",
        login: envSettings.rootPath + "/de/anmelden/",
        loginCaption: "Anmelden",
        news: envSettings.rootPath + "/de/interpretation/aktuelles/",
        newsCaption: "Aktuelles",
        newsLetter: envSettings.rootPath + "/fi/tilaa-uutiskirje/",
        newsLetterCaption: "Tilaa uutiskirje",
        order: envSettings.rootPath + "/fi/tilaa/",
        orderCaption: "Tilaa",
        order2: envSettings.rootPath + "/fi/tilaa-2/",
        orderInterpreter: envSettings.rootPath + "/de/dolmetscher-buchen/",
        orderInterpreterCaption: "Dolmetscher buchen",
        orderInterpreterCaption2: "Dolmetscher buchen",
        orderInterpreter2: envSettings.rootPath + "/de/dolmetscher-buchen/termin-wahlen/",
        orderInterpreter3: envSettings.rootPath + "/de/dolmetscher-buchen/kontaktdaten-des-buchers/",
        orderInterpreter4: envSettings.rootPath + "/de/dolmetscher-buchen-danke/",
        orderOnSiteInterpreter: envSettings.rootPath + "/de/dolmetscher-buchen/dolmetschervorort/",
        orderOnSiteInterpreter2: envSettings.rootPath + "/de/dolmetscher-buchen/dolmetschervorort/termin-wahlen/",
        orderOnSiteInterpreter3: envSettings.rootPath + "/de/dolmetscher-buchen/dolmetschervorort/lage-wahlen/",
        orderOnSiteInterpreter4: envSettings.rootPath + "/de/dolmetscher-buchen/dolmetschervorort/kontaktdaten-des-buchers/",
        orderInstantInterpreter: envSettings.rootPath + "/de/instant-dolmetchen/",
        prices: envSettings.rootPath + "/de/preise/",
        pricesCaption: "Preise",
        privacyPolicy: envSettings.rootPath + "/fi/tietosuoja/",
        privacyPolicyCaption: "Tietosuoja",
        schools: envSettings.rootPath + "/fi/tulkkauspalvelut-kouluille/",
        schoolsCaption: "Tulkkauspalvelut kouluille",
        story: envSettings.rootPath + "/de/youpretaufeinemblick/ ",
        storyCaption: "Youpret auf einen Blick",
        terms: envSettings.rootPath + "/fi/kayttoehdot/",
        termsCaption: "Käyttöehdot",
        video: envSettings.rootPath + "/fi/video/",
        videoCaption: "Video",
        transfer: envSettings.rootPath + "/fi/viestitulkki/",
        transferCaption: "Viestitulkki",
        transferOrder: envSettings.rootPath + "/fi/viestitulkki/tilaa/",
        externalCalendly: "https://calendly.com/youpretcom",
        externalCalendlyCaption: "Varaa maksuton koulutus/esittely",
        harnessLanguageTechnology: envSettings.rootPath + "/en/harness-language-technology/",
        harnessLanguageTechnologyCaption: "Language technology",
        openJobs: envSettings.rootPath + "/fi/avoimet-tyopaikat/harjoittelija/",
        leaveOfferRequest : "Jätä tarjouspyyntö",
        leaveDrivingSchoolOfferRequest : "Autokoulun asiakas, pyydä tarjous tästä",
        leaveDrivingSchoolFlyer: "Autokoulun edustaja, lataa ja jaa esite sinun asiakkaillesi",
        leaveDrivingSchoolFlyerPdf: "/fi/flyer-autokoulun-teoriakoe",
        drivingSchool: envSettings.rootPath + "/fi/tilaa-tulkki/autokoulun-teoriakoe/",
        leaveLegalOfferRequest : "Jätä maksuton tarjouspyyntö",
        orderInterpreterDrivingSchool1: envSettings.rootPath + "/fi/tilaa-tulkki/autokoulun-teoriakoe/valitse-kieli/",
        orderInterpreterDrivingSchool2: envSettings.rootPath + "/fi/tilaa-tulkki/autokoulun-teoriakoe/valitse-sijainti/",
        orderInterpreterDrivingSchool3: envSettings.rootPath + "/fi/tilaa-tulkki/autokoulun-teoriakoe/valitse-ajankohta/",
        orderInterpreterDrivingSchool4: envSettings.rootPath + "/fi/tilaa-tulkki/autokoulun-teoriakoe/tilaajan-yhteystiedot/",
        orderInterpreterDrivingSchool5: envSettings.rootPath + "/fi/tilaa-tulkki/autokoulun-teoriakoe/maksu-ja-vahvistus/",
        orderInterpreterLegal: envSettings.rootPath + "/fi/tilaa-tulkki/oikeustulkki/",
        orderInterpreterLegal1: envSettings.rootPath + "/fi/tilaa-tulkki/oikeustulkki/valitse-kieli/",
        orderInterpreterLegal2: envSettings.rootPath + "/fi/tilaa-tulkki/oikeustulkki/valitse-tulkkauksen-tyyppi/",
        orderInterpreterLegal3: envSettings.rootPath + "/fi/tilaa-tulkki/oikeustulkki/valitse-sijainti/",
        orderInterpreterLegal4: envSettings.rootPath + "/fi/tilaa-tulkki/oikeustulkki/valitse-ajankohta/",
        orderInterpreterLegal5: envSettings.rootPath + "/fi/tilaa-tulkki/oikeustulkki/tilaajan-yhteystiedot/",
        thankYouOfferRequest: envSettings.rootPath + "/de/dolmetscher-buchen/angebot-danke/ ",
        earlyChildhoodEducation: envSettings.rootPath + "/fi/varhaiskasvatusalan-tulkki/",
        earlyChildhoodEducation1: envSettings.rootPath + "/fi/tilaa-tulkki/varhaiskasvatus-tulkki/valitse-kieli/",
        earlyChildhoodEducation2: envSettings.rootPath + "/fi/tilaa-tulkki/varhaiskasvatus-tulkki/valitse-tulkkauksen-tyyppi/",
        earlyChildhoodEducation3: envSettings.rootPath + "/fi/tilaa-tulkki/varhaiskasvatus-tulkki/valitse-sijainti/",
        earlyChildhoodEducation4: envSettings.rootPath + "/fi/tilaa-tulkki/varhaiskasvatus-tulkki/valitse-ajankohta/",
        earlyChildhoodEducation5: envSettings.rootPath + "/fi/tilaa-tulkki/varhaiskasvatus-tulkki/tilaajan-yhteystiedot/",
        orderHealthInterpreter: envSettings.rootPath + "/fi/tilaa-tulkki/terveystulkki/",
        orderHealthInterpreter1: envSettings.rootPath + "/fi/tilaa-tulkki/terveystulkki/valitse-kieli/",
        orderHealthInterpreter2: envSettings.rootPath + "/fi/tilaa-tulkki/terveystulkki/valitse-tulkkauksen-tyyppi/",
        orderHealthInterpreter3: envSettings.rootPath + "/fi/tilaa-tulkki/terveystulkki/valitse-sijainti/",
        orderHealthInterpreter4: envSettings.rootPath + "/fi/tilaa-tulkki/terveystulkki/valitse-ajankohta/",
        orderHealthInterpreter5: envSettings.rootPath + "/fi/tilaa-tulkki/terveystulkki/tilaajan-yhteystiedot/",
        orderBusinessInterpreter: envSettings.rootPath + "/fi/tilaa-tulkki/bisnestulkki/",
        orderBusinessInterpreter1: envSettings.rootPath + "/fi/tilaa-tulkki/bisnestulkki/valitse-kieli/",
        orderBusinessInterpreter2: envSettings.rootPath + "/fi/tilaa-tulkki/bisnestulkki/valitse-tulkkauksen-tyyppi/",
        orderBusinessInterpreter3: envSettings.rootPath + "/fi/tilaa-tulkki/bisnestulkki/valitse-sijainti/",
        orderBusinessInterpreter4: envSettings.rootPath + "/fi/tilaa-tulkki/bisnestulkki/valitse-ajankohta/",
        orderBusinessInterpreter5: envSettings.rootPath + "/fi/tilaa-tulkki/bisnestulkki/tilaajan-yhteystiedot/",
        media: envSettings.rootPath + "/de/medien/",
        mediaCaption: "Medien",
        newsAlustatalous: envSettings.rootPath + "/fi/tulkkaus/ajankohtaista/alustatalous/",
        pageNotFound: envSettings.rootPath + "/fi/sivua-ei-loydy/",
        pageNotFoundTitle: "Sivua ei löytynyt",
        vipuvoimaaEulta: envSettings.rootPath + "/fi/vipuvoimaa-eulta/",
        softwarePage: envSettings.rootPath + "/fi/sovellukset/",
        softwareContactMessage: envSettings.rootPath + "/fi/sovellukset/yhteydenotto-viestinta/",
        specialInterpretationServices: envSettings.rootPath + "/de/dolmetscher-buchen/spezielles-fachwissen/",
        specialInterpretationServicesCaption: "Youprets spezialisierte Dolmetscher*",
        openJobsCaption : "Avoimet työpaikat",
        openJobsPage: envSettings.rootPath + "/fi/avoimet-tyopaikat/",
        openJobsOpenApplicationPage: envSettings.rootPath + "/fi/avoimet-tyopaikat/avoin-hakemus/",
        openJobsOpenApplicationPageCaption: "avoin hakemus",
        openJobCustomerService: envSettings.rootPath + "/fi/tyonkuva/asiakaspalvelija/",
        openJobCustomerServiceCaption: envSettings.rootPath + "Avoin tyopaikka asiakaspalvelija",
        orderIdentifier: "dolmetschervorort",
        youpretAcademy: envSettings.rootPath + "/de/academy/",
        youpretAcademyCaption: "Youpret Academy",
        languageTechnology: envSettings.rootPath + "/en/language-technology/",
        languageTechnologyCaption: "Language technology",
        sustainability: envSettings.rootPath + "/fi/vastuullisuus/",
        sustainabilityCaption: "Vastuullisuus",
        whistleblowing: "/fi/whistleblowing/",
        whistleblowingCaption: "Ilmoituskanava",
        customersGuide: "https://drive.google.com/file/d/1FZM9ya-3x6-N2X1UEg3tMQV10WPgJrCK/view",
        customersGuideLabel: "Lataa tästä"
    },
    is: {
        app: envSettings.rootPath + "/is/youpret-appid/",
        appCaption: "Youpret – bóka túlk",
        bcorpRaport: envSettings.rootPath + " /is/b-corp/",
        bcorpRaportCaption: "B Corp-vottun",
        contact: envSettings.rootPath + " /is/hafdu-samband/",
        contactCaption: "Hafðu samband",
        help: envSettings.rootPath + "/is/hjalp/",
        app: envSettings.rootPath + "/is/youpret-appid/",
        appCaption: "Youpret – bóka túlk",
        bcorpRaport: envSettings.rootPath + " /is/b-corp/",
        bcorpRaportCaption: "B Corp-vottun",
        contact: envSettings.rootPath + " /is/hafdu-samband/",
        help: envSettings.rootPath + "/is/hjalp/",
        home: envSettings.rootPath + "/is/",
        news: envSettings.rootPath + "/is/tulkun/frettir/",
        newsCaption: "Fréttir",
        orderInterpreter: envSettings.rootPath + "/is/panta-tulka/",
        orderInterpreterCaption: "Panta túlk",
        orderInterpreter2: envSettings.rootPath + "/is/panta-tolk/veldu-dag-og-tima/",
        orderInterpreter3: envSettings.rootPath + "/is/panta-tolk/upplysingar-um-vidskiptavin/",
        orderInterpreter4: envSettings.rootPath + "/is/panta-tolk/takk-fyrir/",
        orderOnSiteInterpreter: envSettings.rootPath + "/is/panta-tolk/stadsetning/upplysingar-um-vidskiptavin/",
        orderOnSiteInterpreter2: envSettings.rootPath + "/is/panta-tolk/stadsetning/dagsetning-og-timi/",
        orderOnSiteInterpreter3: envSettings.rootPath + "/is/panta-tolk/stadsetning/tungumal/",
        orderOnSiteInterpreter4: envSettings.rootPath + "/is/panta-tolk/stadsetning/stadsetning/",
        thankYouOfferRequest: envSettings.rootPath + "/is/panta-tolk/stadsetning/takk-fyrir/",
        orderInstantInterpreter: envSettings.rootPath + "/is/skjott-tulkun/",
        orderIdentifier: "stadsetning",
        becomeInterpreter: envSettings.rootPath + "/is/saektu-um-ad-gerast-tulkur/",
        becomeInterpreterCaption: "Sæktu um að gerast túlkur",
        bCorpPage: envSettings.rootPath +  "https://www.bcorporation.net/en-us/find-a-b-corp/company/youpret-oy/",
        sustainabilityReport: envSettings.rootPath +  "https://drive.google.com/file/d/1-_i0L0SSW2vwo1ShNWut1G0ENDC_p12B/view?usp=sharing", // Todo? on englanniksi
        appPageAndroid: "https://play.google.com/store/apps/details?id=com.youpret.app",
        appPageIOS: "https://apps.apple.com/is/app/youpret-tilaa-tulkki/id6448171685",
        bCorpBlog: envSettings.rootPath +  "/is/tulkun/frettir/youpret-fyrsta-b-corp-vottada-tungumalathjonustan-a-nordurlondunum/",
        bcorpPart2blogPost: envSettings.rootPath + "/is/tulkun/frettir/youpret-fyrsta-b-corp-vottada-tungumalathjonustan-a-nordurlondunum/",
        createAccountCaption: "Stofnaðu reikning",
        createAccount: envSettings.rootPath + "/is/stofnadu-reikning/",
        thankYouPage: envSettings.rootPath + "/is/takk-fyrir/",
        prices: envSettings.rootPath +  " /is/verdin/",
        pricesCaption: "Verðin",
        sustainability: envSettings.rootPath +  "/is/sjalfbaerniskyrsluna-okkar/",
        sustainabilityCaption: "Sjálfbærni",
    },
    ee: {
        app: envSettings.rootPath + "/ee/youpret-app",
        appCaption: "TODO",
        bcorpRaport: envSettings.rootPath + "/ee/b-corp",
        bcorpRaportCaption: "B-corp",
        contact: envSettings.rootPath + "/ee/contact",
        contactCaption: "TODO",
        help: envSettings.rootPath + "/ee/help",
        home: envSettings.rootPath + "/ee/",
        news: envSettings.rootPath + "/ee/news",
        newsCaption: "TODO",
        orderInterpreter: envSettings.rootPath + "/ee/tilaa-tulkki/",
        orderInterpreterCaption: "Tilaa tulkki",
        orderInterpreterCaption2: "Tilaa tulkki -sivulta",
        orderInterpreter2: envSettings.rootPath + "/ee/tilaa-tulkki/valitse-ajankohta/",
        orderInterpreter3: envSettings.rootPath + "/ee/tilaa-tulkki/tilaajan-yhteystiedot/",
        orderInterpreter4: envSettings.rootPath + "/ee/tilaa-tulkki-kiitos/",
        orderOnSiteInterpreter: envSettings.rootPath + "/ee/tilaa-tulkki/lasnaolotulkki/valitse-kieli/",
        orderOnSiteInterpreter2: envSettings.rootPath + "/ee/tilaa-tulkki/lasnaolotulkki/valitse-ajankohta/",
        orderOnSiteInterpreter3: envSettings.rootPath + "/ee/tilaa-tulkki/lasnaolotulkki/valitse-sijainti/",
        orderOnSiteInterpreter4: envSettings.rootPath + "/ee/tilaa-tulkki/lasnaolotulkki/tilaajan-yhteystiedot/",
        orderInstantInterpreter: envSettings.rootPath + "/ee/tilaa-pikatulkki/",
        thankYouOfferRequest: envSettings.rootPath + "/ee/tilaa-tulkki/tarjouspyynto-kiitos/",
        thankYouPage: envSettings.rootPath + "/ee/kiitos/",

        orderIdentifier: "TODO",
        becomeInterpreter: envSettings.rootPath + "TODO",
        becomeInterpreterCaption: "TODO",
        bCorpPage: envSettings.rootPath +  "TODO",
        sustainabilityReport: envSettings.rootPath +  "TODO", // Todo? on englanniksi
        appPageAndroid: "https://play.google.com/store/apps/details?id=com.youpret.app",
        appPageIOS: "https://apps.apple.com/ee/app/youpret-tilaa-tulkki/id6448171685",
        bCorpBlog: envSettings.rootPath +  "TODO",
        createAccountCaption: "TODO",
        createAccount: envSettings.rootPath + "TODO",
        thankYouPage: envSettings.rootPath + "TODO",
        prices: envSettings.rootPath +  "TODO",
        pricesCaption: "TODO",
        sustainability: envSettings.rootPath +  "TODO",
        sustainabilityCaption: "TODO",
    },
};